import React, { PropsWithChildren } from 'react';
import { Row, Col } from 'reactstrap';
import './index.css';

export type ItemContainerFooterProps = {};

const ItemContainerFooter = ({
  children,
}: PropsWithChildren<ItemContainerFooterProps>) => (
  <Row noGutters className="ic-footer m-2">
    <Col>{children}</Col>
  </Row>
);

export default ItemContainerFooter;
